export default "__VITE_ASSET__DfmjgGUS__"